import { c as _c } from "react/compiler-runtime";
import type { Dispatch, SetStateAction } from 'react';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import type { DetailedStore } from '@spa/components/storefinder/interfaces';
import type { ProductInfoProduct } from '../ProductInfoProductTypes';
import classNames from 'clsx';
import { isShopStoreType } from '@spa/lib/configs/storeType';
import styles from './store-availability.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export type StoreAvailabilityProps = {
  setSelectedProduct: Dispatch<SetStateAction<ProductInfoProduct | undefined>>;
  setShowStoreFinderPopup: Dispatch<SetStateAction<boolean>>;
  product: ProductInfoProduct;
  availableAtSelectedStore: boolean;
  loadingErrorAvailability: boolean;
  selectedStore?: DetailedStore;
};
export const StoreAvailability = props => {
  const $ = _c(19);
  const {
    setSelectedProduct,
    setShowStoreFinderPopup,
    availableAtSelectedStore,
    loadingErrorAvailability,
    selectedStore,
    product
  } = props;
  const {
    formatMessage
  } = useNamespacedIntl("product-info");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classNames(styles["store-availability"], {
      [styles["store-availability--has-primary-button"]]: !isShopStoreType
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== availableAtSelectedStore || $[2] !== formatMessage || $[3] !== loadingErrorAvailability || $[4] !== selectedStore) {
    t1 = selectedStore !== undefined && <span className="body-bold">{selectedStore.name}:  {loadingErrorAvailability ? <span>{formatMessage("loadingError")}</span> : <span className={availableAtSelectedStore ? `${styles.available}` : `${styles.unavailable}`}>{formatMessage(availableAtSelectedStore ? "available" : "unavailable")}</span>}</span>;
    $[1] = availableAtSelectedStore;
    $[2] = formatMessage;
    $[3] = loadingErrorAvailability;
    $[4] = selectedStore;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = selectedStore !== undefined ? "checkAvailabilityInOtherStores" : "checkAvailability";
  let t3;
  if ($[6] !== formatMessage || $[7] !== t2) {
    t3 = formatMessage(t2);
    $[6] = formatMessage;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== product || $[10] !== setSelectedProduct || $[11] !== setShowStoreFinderPopup) {
    t4 = () => {
      setSelectedProduct(product);
      setShowStoreFinderPopup(true);
    };
    $[9] = product;
    $[10] = setSelectedProduct;
    $[11] = setShowStoreFinderPopup;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <ButtonComponent buttonType={isShopStoreType ? ButtonType.AS_TEXT : ButtonType.PRIMARY} text={t3} onClick={t4} />;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t1 || $[17] !== t5) {
    t6 = <div className={t0}>{t1}{t5}</div>;
    $[16] = t1;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};